import React from 'react';
import moment from 'moment/moment';
import { grey } from '@mui/material/colors';
import { DateFormats } from 'constants/common';
import { Send, Link } from '@mui/icons-material';
import { MUITableColumn } from 'components/shared/MUITable';
import { capitalize, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { CreditSubmissionProposalEntity } from './CreditSubmissionProposalsTable';
import { proposalColorStatusByTitle } from '../../../constants';

export function createTableColumns({
  handleProposalRowClick,
  handleRedirectToProposalPage,
}: {
  handleProposalRowClick: (id: string) => void;
  handleRedirectToProposalPage: (id: string, dynamicsAccountId: string | null) => void;
}): MUITableColumn<CreditSubmissionProposalEntity>[] {
  return [
    {
      header: 'Created On',
      renderKey: 'createdDateTime',
      sortKey: 'created_date_time',
      formatter: value => moment(+value.createdDateTime).format(DateFormats.DateTimeShort24Hour),
    },
    {
      header: 'Company',
      sortKey: 'business_name',
      renderKey: 'businessName',
    },
    {
      header: 'Contact',
      renderKey: 'contactName',
    },
    {
      header: 'Amount',
      sortKey: 'amount_requested',
      renderKey: 'amountRequested',
    },
    {
      header: 'Status',
      sortKey: 'status',
      renderKey: 'status',
      renderCell: ({ status }) => (
        <Stack
          sx={{
            padding: '4px 8px',
            width: 'fit-content',
            alignItems: 'center',
            borderRadius: '0.5rem',
            display: 'inline-flex',
            justifyContent: 'center',
            backgroundColor: proposalColorStatusByTitle[status] ?? grey[50],
          }}
        >
          <Typography>{capitalize(status) ?? 'Draft'}</Typography>
        </Stack>
      ),
    },
    {
      header: 'Owner',
      renderKey: 'salesPersonName',
    },
    {
      header: 'Resend',
      renderKey: 'id',
      renderCell: ({ id, dynamicsAccountId }) => (
        <Stack direction="row" gap="0.5rem" justifyContent="center">
          <Tooltip title="View detaild">
            <IconButton
              size="small"
              onClick={() => {
                handleProposalRowClick(id.toString());
              }}
            >
              <Send color="primary" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Visit proposal page">
            <IconButton
              size="small"
              onClick={() => {
                handleRedirectToProposalPage(id.toString(), dynamicsAccountId);
              }}
            >
              <Link color="primary" />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
  ];
}
